/**
 * De referentiecode van een plan-run, zoals die in een foutmelding aan de planner getoond wordt.
 *
 * Spiegelt PlanRunReference.cs. Dubbel uitgeschreven omdat de melding ook moet kloppen wanneer de samenvatting
 * niet opgehaald is — juist bij een technische fout is dat het geval, en dan is deze code het enige dat beheer
 * kan terugzoeken.
 */
export const planRunReference = (planRunId: number): string => `APE-${planRunId}`;
